(() => {
  const rootSelector = '.nca-root';
  const mountSelector = '[data-neat-commerce-agent]';
  const assistantSelector = `${rootSelector}, ${mountSelector}`;

  const includeAssistant = (current) => {
    if (!current) return assistantSelector;
    return current.includes(rootSelector) ? current : `${current}, ${assistantSelector}`;
  };

  const excludeFromCartApps = () => {
    const zipify = (window.Zipify = window.Zipify || {});
    zipify.Cart = zipify.Cart || { api: {}, integrations: {} };
    zipify.Cart.api = zipify.Cart.api || {};
    zipify.Cart.api.excludeActionButton = includeAssistant(zipify.Cart.api.excludeActionButton);
  };

  const position = (root) => {
    if (document.body && root.parentElement !== document.body) {
      document.body.appendChild(root);
    }

    if (root.dataset.zeeRoutineOffsetBound === 'true') return;

    root.dataset.zeeRoutineOffsetBound = 'true';
    root.style.setProperty('bottom', '20px', 'important');

    new MutationObserver(() => {
      if (root.dataset.open === 'false') {
        root.style.setProperty('bottom', '20px', 'important');
      }
    }).observe(root, { attributes: true, attributeFilter: ['data-open'] });
  };

  const positionAll = () => {
    excludeFromCartApps();
    document.querySelectorAll(rootSelector).forEach(position);
  };

  excludeFromCartApps();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', positionAll, { once: true });
  } else {
    positionAll();
  }

  new MutationObserver(positionAll).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
